/**
 * 查询参数 OPENTYPE 等于订单类型
 */
export const QUERY_FROM_ORDER = 'order';

/**
 * 查询参数 OPENTYPE 等于活动类型
 */
export const QUERY_OPENTYPE_ACTIVITY = 'activity';

/**
 * 查询参数 OPENTYPE 等于促销文章类型
 */
export const QUERY_OPENTYPE_PROMOTION = 'promotion';

/**
 * 查询参数 OPENTYPE 等于促销活动类型
 */
export const QUERY_OPENTYPE_PROMOTIONACTIVITY = 'promotionactivity';

/**
 * 查询参数 from 等于云视频
 */
export const QUERY_FROM_CLOUDVIDEO = 'cloudvideo';

/**
 * 查询参数 from 等于百度小程序
 */
export const QUERY_FROM_BDXIAOCHENGXU = 'bdxiaochengxu';

/**
 * 查询参数 from 等于微信小程序
 */
export const QUERY_FROM_XIAOCHENGXU = 'xiaochengxu';

/**
 * 查询参数 from 等于高德小程序
 */
export const QUERY_FROM_GDXIAOCHENGXU = 'gdxiaochengxu';

/**
 * 查询参数 from 等于sahuan 不清楚含义
 */
export const QUERY_FROM_SAHUAN = 'sahuan';

/**
 * 查询参数 from 等于团购
 */
export const QUERY_FROM_TUAN = 'tuan';

/**
 * 查询参数 busi 等于智效店铺
 */
export const QUERY_BUSI_SMARTSTORE = 'smartstore';

/**
 * 查询参数 busi 等于召回广告
 */
export const QUERY_BUSI_SMARTADVERT = 'smartadvert';

/**
 * 查询参数 sceneType 等于 3d 场景
 */
export const QUERY_SCENETYPE_3D = '3d';

/**
 * 查询参数 sceneType 等于 full 实景
 */
export const QUERY_SCENETYPE_FULL = 'full';

/**
 * 查询参数 hallType 等于 3d 场景
 */
export const QUERY_HALLTYPE_3D = '3d';

/**
 * 可以弹出活动的类型
 */
export const CAN_OPEN_ACTIVITY_TYPES = [1, 2, 3, 4, 5];

/**
 * 查询参数 OPENTYPE 等于促销活动类型
 */
export const QUERY_OPENTYPE_3DCAR = '3dcar';

/**
 *  查询参数 OPENTYPE 为VR带看引导
 */
export const QUERY_REALTIME_GUIDE = 'realtimeguide';
